import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 5000-5999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const organisationErrors = {
  ORGANISATION_NOT_EXIST: {
    errorCode: 5001,
    errorMessage: t("Organisation does not exist"),
    isDynamic: false,
  },
  ORGANISATION_NO_FIELDS_TO_UPDATE: {
    errorCode: 5003,
    errorMessage: t("No organisation fields were supplied to update."),
    isDynamic: false,
  },
  ORGANISATION_IDS_REQUIRED: {
    errorCode: 5004,
    errorMessage: t("organisationIds is required"),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
